import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AdminFormComponent } from './components/admin-form/admin-form.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExpandableListComponent } from './components/expandable-list/expandable-list.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { AuthGuard } from './auth-guard.guard';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DetailedApplicationInfoComponent } from './components/detailed-application-info/detailed-application-info.component';
import { DetailedApplicationFormComponent } from './components/detailed-application-form/detailed-application-form.component';
import { OtherInfoModalComponent } from './components/other-info-modal/other-info-modal.component';
import { MailModalComponent } from './components/mail-modal/mail-modal.component';
import { AttachmentEditModalComponent } from './components/attachment-edit-modal/attachment-edit-modal.component';
import { UiModule } from '../ui/ui.module';
import { PrintApplicationComponent } from './components/print-application/print-application.component';
import { NgxPrintModule } from 'ngx-print';

@NgModule({
  declarations: [
    AdminFormComponent,
    ExpandableListComponent,
    LoginFormComponent,
    DetailedApplicationInfoComponent,
    DetailedApplicationFormComponent,
    OtherInfoModalComponent,
    MailModalComponent,
    AttachmentEditModalComponent,
    PrintApplicationComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    UiModule,
    NgxPrintModule,
    RouterModule.forChild([
      {
        path: 'admin',
        component: AdminFormComponent,
        canActivate: [AuthGuard]
      }
    ])
  ],
  providers: []
})
export class AdminModule {}
